import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PreviewIcon from '@mui/icons-material/Preview';
import PsychologyIcon from '@mui/icons-material/Psychology';
import PublishIcon from '@mui/icons-material/Publish';
import RefreshIcon from '@mui/icons-material/Refresh';
import SyncIcon from '@mui/icons-material/Sync';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import DataTable from 'react-data-table-component';
import { useDispatch } from 'react-redux';

import { clearSpinner, setSpinner } from '../../app_store/actions/spinner';
import {
    fetchLabOrderAIQReportLogs,
    labOrderAction,
    labOrderGenerateReport,
    publishLabOrders,
    runAiq,
} from '../../services/labOrder.service';
import { customTableStyles, dateTimeFormat, showPhenoTypes } from '../../utils';
import PxPopup from '../PxPopUp.component';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import NotifyConfirmation from '../notifyConfirmation.component';
import ReportDownload from '../report/reportDownload.Component';
import ViewLabStatusLogs from './processingStatusLog.component';

const AIQReportLogs = props => {
    const [statusLogs, setStatusLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [show, setModalShow] = useState(props.open);
    const [previewPdf, setPreviewPdf] = useState({
        url: '',
        summaryUrl: '',
    });
    const [openViewReport, setOpenViewReport] = useState(false);
    const [accordianKey, setAccordiankey] = useState('ProcessingStatusLog');
    const [modelSelectedRow, setModelSelectedRow] = useState();
    const [modelActionItems, setModelActionItems] = useState({
        showNotifyConfirmation: false,
        actionButtonName: '',
        actionTitleName: '',
    });
    const dispatch = useDispatch();

    const reRunAiq = async () => {
        dispatch(setSpinner());
        try {
            const resp = await runAiq(props.selectedRow);

            setMessage({
                type: 'Success',
                message: `${resp.detail}`,
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        dispatch(clearSpinner());
    };

    useEffect(() => {
        setModalShow(props.open);
        getStatusLogs(props.selectedRow.id);
        setMessage({});
    }, [props.selectedRow]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleModalClose = () => {
        setModalShow(false);
        props.setOpenAIQModel(false);
        if (Object.keys(message).length !== 0) {
            props.reloadDataTable(1);
        }
    };

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
        },
        {
            name: 'Pheno Types',
            cell: row => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {showPhenoTypes(row.pheno_types)}
                    </div>
                );
            },
            width: '15%',
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Algo Version',
            cell: row => {
                return (
                    <>
                        <PxPopup
                            title={row.algo_version}
                            description={JSON.stringify(
                                JSON.parse(row.algo_ver_desc),
                                null,
                                2,
                            )}
                            valueType="JSON"
                        />
                    </>
                );
            },
        },
        {
            name: 'Report Version',
            cell: row => {
                return (
                    <>
                        <PxPopup
                            title={row.report_version}
                            description={JSON.stringify(
                                JSON.parse(row.report_ver_desc),
                                null,
                                2,
                            )}
                            valueType="JSON"
                        />
                    </>
                );
            },
        },
        {
            name: 'Created at',
            selector: row => dateTimeFormat(row.created_at),
        },
        {
            key: 'action',
            text: 'Action',
            name: 'Action',
            className: 'action',
            width: '130px',
            align: 'left',
            sortable: false,
            cell: row => {
                return (
                    <div>
                        {(row.status.toLowerCase() ===
                            'Aiq Job - Success'.toLowerCase() ||
                            row.status.toLowerCase() ===
                                'Report revoked'.toLowerCase() ||
                            row.status.toLowerCase() ===
                                'Report revoked'.toLowerCase() ||
                            row.status.toLowerCase() ===
                                'Report released'.toLowerCase() ||
                            row.status.toLowerCase() ===
                                'Report generation completed'.toLowerCase()) && (
                            <span
                                className="table-action-icon"
                                title="Generate Report">
                                <RefreshIcon
                                    className="icon-color"
                                    onClick={() => {
                                        setModelActionItems({
                                            showNotifyConfirmation: true,
                                            actionButtonName: 'Generate',
                                            actionTitleName:
                                                'Are you sure want to genrate report',
                                        });
                                        setModelSelectedRow(row);
                                    }}
                                />
                            </span>
                        )}
                        {row.report_version &&
                            (row.status.toLowerCase() ===
                                'Report generation completed'.toLowerCase() ||
                                row.status.toLowerCase() ===
                                    'Report revoked'.toLowerCase()) && (
                                <span
                                    className="table-action-icon"
                                    title="Publish Report">
                                    <PublishIcon
                                        className="icon-color"
                                        onClick={() => {
                                            setModelActionItems({
                                                showNotifyConfirmation: true,
                                                actionButtonName: 'Publish',
                                                actionTitleName:
                                                    'Are you sure want to publish report',
                                            });
                                            setModelSelectedRow(row);
                                        }}
                                    />
                                </span>
                            )}
                        {row.report_version &&
                            (row.status.toLowerCase() ===
                                'Report generation completed'.toLowerCase() ||
                                row.status.toLowerCase() ===
                                    'Report revoked'.toLowerCase() ||
                                row.status.toLowerCase() ===
                                    'Report released'.toLowerCase()) && (
                                <span
                                    className="table-action-icon"
                                    title="Preview Report">
                                    <PreviewIcon
                                        className="icon-color"
                                        onClick={() => {
                                            onPreview(row);
                                        }}
                                    />
                                </span>
                            )}
                        {row.report_version &&
                            row.status.toLowerCase() ===
                                'Report released'.toLowerCase() && (
                                <span
                                    className="table-action-icon"
                                    title="Revoke Report">
                                    <UnpublishedIcon
                                        className="red"
                                        onClick={() => {
                                            setModelActionItems({
                                                showNotifyConfirmation: true,
                                                actionButtonName: 'Revoke',
                                                actionTitleName:
                                                    'Are you sure want to revoke report',
                                            });
                                            setModelSelectedRow(row);
                                        }}
                                    />
                                </span>
                            )}
                    </div>
                );
            },
        },
    ];

    const getStatusLogs = async labOrderId => {
        setLoading(true);
        if (labOrderId) {
            try {
                const resp = await fetchLabOrderAIQReportLogs(labOrderId);
                setStatusLogs(resp);
            } catch (error) {
                console.log(error);
            }
        }

        setLoading(false);
    };

    const onRevoke = async row => {
        dispatch(setSpinner());
        try {
            await publishLabOrders(props.selectedRow.id, 'REVOKE', row.id);
            getStatusLogs(props.selectedRow.id);
            setMessage({
                type: 'Success',
                message: `Result has been revoked successfully`,
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        dispatch(clearSpinner());
    };

    const onPublish = async row => {
        dispatch(setSpinner());
        try {
            await publishLabOrders(props.selectedRow.id, 'PUBLISH', row.id);
            getStatusLogs(props.selectedRow.id);
            setMessage({
                type: 'Success',
                message: `Result has been published successfully`,
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        dispatch(clearSpinner());
    };

    const onPreview = async row => {
        dispatch(setSpinner());

        Promise.all([
            labOrderAction(props.selectedRow.id, 'detail', row.id),
            labOrderAction(props.selectedRow.id, 'summary', row.id),
        ])
            .then(([detailResult, summaryResult]) => {
                setPreviewPdf({
                    url: detailResult.url,
                    summaryUrl: summaryResult.url,
                });
                setOpenViewReport(true);
            })
            .catch(error => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 404
                ) {
                    setMessage({
                        type: 'Error',
                        message: `${error.response.data.detail}`,
                    });
                }
            });
        dispatch(clearSpinner());
    };

    const onGenerate = async row => {
        dispatch(setSpinner());
        try {
            await labOrderGenerateReport(props.selectedRow.id, row.id);
            getStatusLogs(props.selectedRow.id);
            setMessage({
                type: 'Success',
                message: 'Report Generation is in progress',
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        dispatch(clearSpinner());
    };

    const takeAction = async row => {
        if (modelActionItems.actionButtonName === 'Revoke') onRevoke(row);
        else if (modelActionItems.actionButtonName === 'Generate')
            onGenerate(row);
        else if (modelActionItems.actionButtonName === 'Publish')
            onPublish(row);
    };

    return (
        <AppModal
            size="xl"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="AIQ run history">
            {openViewReport && (
                <ReportDownload
                    url={previewPdf.url}
                    open={openViewReport}
                    handleReportClose={setOpenViewReport}
                    summaryUrl={previewPdf.summaryUrl}
                />
            )}
            {message && <MessageContainer message={message} />}
            <p style={{ margin: 0, padding: 0 }}>
                Lab Order Id : {props.selectedRow.id}
            </p>
            <p style={{ margin: 0, padding: 0 }}>
                Sample ID : {props.selectedRow.sample_id}
            </p>
            <div
                id="header-add-btn"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                <span
                    color="primary"
                    className="pointer-cursor float-right"
                    style={{ marginRight: '10px', marginLeft: '10px' }}
                    onClick={() => {
                        getStatusLogs(props.selectedRow.id);
                    }}>
                    <SyncIcon />
                </span>
                <span>
                    <button
                        className={
                                props.selectedRow.algo_version_id !==
                                props.selectedRow.current_algo_version_id
                                    ? 'btn btn-secondary'
                                    : 'btn btn-primary'
                            }
                        disabled={
                            props.selectedRow.algo_version_id !==
                            props.selectedRow.current_algo_version_id
                        }
                        onClick={() => {
                            reRunAiq();
                        }}>
                        <PsychologyIcon style={{ marginBottom: '3px' }} />{' '}
                        &nbsp;Run AIQ
                    </button>
                </span>
            </div>

            <div className="mt-3">
                <DataTable
                    width="100%"
                    customStyles={customTableStyles}
                    columns={columns}
                    data={statusLogs}
                    progressPending={loading}
                />
            </div>

            <div className="col-md-12 mt-2">
                <Accordion
                    defaultActiveKey="ProcessingStatusLog"
                    flush
                    onSelect={key => {
                        setAccordiankey(key);
                    }}>
                    <Accordion.Item eventKey="ProcessingStatusLog">
                        <Accordion.Header>
                            <LibraryBooksIcon />
                            <>&nbsp;</>
                            Processing Status Log
                        </Accordion.Header>
                        <Accordion.Body>
                            {accordianKey === 'ProcessingStatusLog' && (
                                <>
                                    <div className="new-line" />
                                    <ViewLabStatusLogs
                                        labOrder={props.selectedRow}
                                    />
                                </>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
            {modelActionItems.showNotifyConfirmation && (
                <NotifyConfirmation
                    showModal={modelActionItems.showNotifyConfirmation}
                    hideModal={() => {
                        setModelActionItems({
                            showNotifyConfirmation: false,
                            actionButtonName: '',
                            actionTitleName: '',
                        });
                    }}
                    confirmModal={takeAction}
                    notifyAccountId={modelSelectedRow}
                    buttonName={modelActionItems.actionButtonName}
                    message={modelActionItems.actionTitleName}
                />
            )}
        </AppModal>
    );
};

export default AIQReportLogs;
